var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#010080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9H9C8.60218 9 8.22064 9.15804 7.93934 9.43934C7.65804 9.72064 7.5 10.1022 7.5 10.5V17.5C7.5 17.8978 7.65804 18.2794 7.93934 18.5607C8.22064 18.842 8.60218 19 9 19H19C19.3978 19 19.7794 18.842 20.0607 18.5607C20.342 18.2794 20.5 17.8978 20.5 17.5V10.5C20.5 10.1022 20.342 9.72064 20.0607 9.43934C19.7794 9.15804 19.3978 9 19 9ZM15.5 13.5C15.5 13.8978 15.342 14.2794 15.0607 14.5607C14.7794 14.842 14.3978 15 14 15C13.6022 15 13.2206 14.842 12.9393 14.5607C12.658 14.2794 12.5 13.8978 12.5 13.5C12.5 13.3674 12.4473 13.2402 12.3536 13.1464C12.2598 13.0527 12.1326 13 12 13H8.5V12H19.5V13H16C15.8674 13 15.7402 13.0527 15.6464 13.1464C15.5527 13.2402 15.5 13.3674 15.5 13.5ZM9 10H19C19.1326 10 19.2598 10.0527 19.3536 10.1464C19.4473 10.2402 19.5 10.3674 19.5 10.5V11H8.5V10.5C8.5 10.3674 8.55268 10.2402 8.64645 10.1464C8.74021 10.0527 8.86739 10 9 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDefault);
export default __webpack_public_path__ + "static/media/card-default.cbf6da8ed24096fe8ba698b78a10b993.svg";
export { ForwardRef as ReactComponent };